import type { MedVisitBulkUpdatePatch } from "@/types/medchron";

import type { VisitDisplay } from "../types";

export function applyBulkVisitPatchToList(
  visits: VisitDisplay[],
  visitIds: string[],
  bulkPatch: MedVisitBulkUpdatePatch
): VisitDisplay[] {
  const updatedIds = new Set(visitIds);

  return visits.map((visit) => {
    if (!visit.allVisits?.length) {
      return updatedIds.has(visit.visit_id) ? { ...visit, ...bulkPatch } : visit;
    }

    const allChildrenUpdated = visit.allVisits.every((child) => updatedIds.has(child.visit_id));
    const updatedChildren = visit.allVisits.map((child) =>
      updatedIds.has(child.visit_id) ? { ...child, ...bulkPatch } : child
    );

    if (allChildrenUpdated) {
      return { ...visit, ...bulkPatch, allVisits: updatedChildren };
    }

    return { ...visit, allVisits: updatedChildren };
  });
}

export function removeDeletedVisitsFromList(
  visits: VisitDisplay[],
  deletedVisitIds: Iterable<string>
): VisitDisplay[] {
  const deletedIds = new Set(deletedVisitIds);

  return visits
    .map((visit) => {
      if (deletedIds.has(visit.visit_id)) {
        return null;
      }

      if (!visit.allVisits?.length) {
        return visit;
      }

      const nextChildren = visit.allVisits.filter((child) => !deletedIds.has(child.visit_id));
      if (nextChildren.length === 0) {
        return null;
      }
      if (nextChildren.length === visit.allVisits.length) {
        return visit;
      }

      return {
        ...visit,
        allVisits: nextChildren,
        visitCount: nextChildren.length,
      };
    })
    .filter((visit): visit is VisitDisplay => visit !== null);
}
